/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var YesNoNotRequired;

(function (YesNoNotRequired) {
  YesNoNotRequired["YES"] = "Yes";
  YesNoNotRequired["NO"] = "No";
  YesNoNotRequired["NOT_REQUIRED"] = "Not Required";
})(YesNoNotRequired || (YesNoNotRequired = {}));